"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanValidator = void 0;
const Validator_1 = require("./Validator");
class BooleanValidator extends Validator_1.Validator {
    static isBoolean(value) {
        return typeof value === 'boolean';
    }
    static isTruthy(value) {
        return value === true;
    }
    static isFalsy(value) {
        return value === false;
    }
}
exports.BooleanValidator = BooleanValidator;
_a = BooleanValidator;
BooleanValidator.IS_BOOLEAN = () => _a.validatorFactory('IS_BOOLEAN', _a.isBoolean);
BooleanValidator.IS_TRUTHY = () => _a.validatorFactory('IS_TRUTHY', _a.isTruthy);
BooleanValidator.IS_FALSY = () => _a.validatorFactory('IS_FALSY', _a.isFalsy);
//# sourceMappingURL=BooleanValidator.js.map